export enum VideoType {
    Live,
    Complementary,
    Mentorship,
    Theory,
    Resolution
}
